export const SEGMENTS_TABLE_APPCUES_ID = {
    INSIGHT_HEADER: 'SEGMENTS_TABLE_INSIGHT_HEADER',
};

export const SEGMENTS_TABLE_HEADER_TEXTS = {
    TITLE: 'Segments Table',
    SUBTITLE: 'A deep dive view of your segments.',
    PLACEHOLDER: 'Search segments...',
};
